import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ar from './locales/ar.json';
import en from './locales/en.json';
import es from './locales/es.json';

// Get saved language preference or default from env
const defaultLanguage = import.meta.env.DEFAULT_LANGUAGE || 'en';
const savedLanguage = localStorage.getItem('i18nextLng') || defaultLanguage;

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            ar: { translation: ar },
            en: { translation: en },
            es: { translation: es }
        },
        lng: savedLanguage, // Use saved language as initial language
        fallbackLng: defaultLanguage, // Use env default as fallback
        interpolation: {
            escapeValue: false
        },
        detection: {
            // Order: check localStorage first, then URL query, then browser language
            order: ['localStorage', 'querystring', 'navigator'],
            // We handle caching manually to avoid browser defaults overriding server defaults on first visit
            caches: [],
            lookupQuerystring: 'lang',
            lookupLocalStorage: 'i18nextLng'
        }
    });

// Listen for language changes and update localStorage
i18n.on('languageChanged', (lng) => {
    // Only save if it's a valid language we support
    if (['en', 'ar', 'es'].includes(lng)) {
        localStorage.setItem('i18nextLng', lng);
    }
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lng;
});

// Set initial direction
document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;
